'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  active: '<a class="ais-show-more ais-show-more__active">Show less</a>',
  inactive: '<a class="ais-show-more ais-show-more__inactive">Show more</a>'
};


// WEBPACK FOOTER //
// ./~/instantsearch.js/dist-es5-module/src/lib/show-more/defaultShowMoreTemplates.js